import { useQuery } from '@tanstack/react-query';
import { useUniversalNavContext } from './useUniversalNavContext';
export function useQueryPermissions() {
    const { apiHostname } = useUniversalNavContext();
    const result = useQuery({
        queryKey: ['permissions'],
        queryFn: async () => {
            const url = new URL(`/api/v1/access/permissions`, apiHostname || window.location.origin);
            const response = await fetch(url.toString(), {
                credentials: 'include',
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const json = await response.json();
            return json;
        },
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 60,
    });
    return Object.assign(Object.assign({}, result), { isLoading: result.isInitialLoading });
}
//# sourceMappingURL=useQueryPermissions.js.map
// @zapier/universal-layout@12.2.7 (b1fe70032)
